import React from 'react';

import { useSelector } from 'react-redux';

import clsx from 'clsx';

import { useDevice } from '@bonnet/next/device';

import { Button, Glyphicon } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { shoppingAssistantIconClick } from 'reaxl-analytics-handlers';

import srpFixedAdDuck from '@/ducks/srp/srpFixedAdDuck.js';

import ShoppingAssistantPopover from './ShoppingAssistantPopover';

function ShoppingAssistantContainer({
    handleAssistantClose,
    headingText,
    setShowAssistant,
    showAssistant,
    suggestedActions,
}) {
    const device = useDevice();
    const isXs = device?.is?.xs;

    const scrolled = useSelector(srpFixedAdDuck.selectors.getScrolled);
    const closeFixedAd = useSelector(srpFixedAdDuck.selectors.getCloseFixedAd);

    const paddingWithoutAd = isXs ? '20px' : '30px';
    const paddingWithAd = isXs ? '70px' : '100px';

    const handleAssistantClick = (event) => {
        sendClick(shoppingAssistantIconClick, event, {});
        setShowAssistant((prev) => !prev);
    };

    const adjustedBottomPadding = scrolled && !closeFixedAd ? paddingWithAd : paddingWithoutAd;

    return (
        <div
            className="shopping-assistant"
            style={{ bottom: adjustedBottomPadding }}
        >
            <ShoppingAssistantPopover
                className={clsx({ 'margin-bottom-5 margin-right-3': !isXs })}
                containerElement={{ offsetWidth: 400 }}
                handleAssistantClose={handleAssistantClose}
                headingText={headingText}
                show={showAssistant}
                suggestedActions={suggestedActions}
            />
            <Button
                id="shopping-assistant-entry"
                className="text-size-500 cursor-pointer pull-right padding-vertical-1 padding-horizontal-3 "
                onClick={handleAssistantClick}
            >
                <Glyphicon
                    className="text-inverse"
                    glyph="sparkles"
                />
            </Button>
        </div>
    );
}

export default ShoppingAssistantContainer;
